import formatError from '@/helpers/formatError';

const apiCall = cb =>
  // eslint-disable-next-line
  async function(...args) {
    this.loading = true;
    try {
      await cb.apply(this, args);
    } catch (e) {
      this.$notify({
        group: 'error',
        type: 'error',
        text: formatError(e),
      });
    }
    this.loading = false;
  };

export default apiCall;



// WEBPACK FOOTER //
// ./src/helpers/stepperApiCall.js